import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import styles from './OrganizerStats.module.scss';
import type { OrganizerWithFollowStatus } from '@/components/OrganizerCard/types';

const Stat = ({ label, data, divider }: { label: string; data: string | number; divider: boolean }) => {
  const statUnitClasses = classNames(styles.stat, { [styles.statWithDivider]: divider });

  return (
    <div className={statUnitClasses}>
      <span className={styles.label}>{label}</span>
      <span className={styles.data}>{data}</span>
    </div>
  );
};

interface OrganizerStatsProps {
  organizer: OrganizerWithFollowStatus;
}

export const OrganizerStats: React.FC<OrganizerStatsProps> = ({ organizer }) => {
  const { formatMessage } = useIntl();

  const NO_AVAILABLE_DATA = '--';

  const numberOfFollowers = organizer.followStatus?.numFollowers || NO_AVAILABLE_DATA;
  const numberOfEvents = organizer.numEvents || NO_AVAILABLE_DATA;
  const hostingSinceText =
    organizer.hostingSince !== undefined && organizer.hostingSince > 0
      ? `${organizer.hostingSince} ${formatMessage({ id: 'years' })}`
      : NO_AVAILABLE_DATA;

  return (
    <div className={styles.wrapper} data-testid="organizer-stats">
      <Stat label={formatMessage({ id: 'Followers' })} data={numberOfFollowers} divider={false} />
      <Stat label={formatMessage({ id: 'Events' })} data={numberOfEvents} divider={true} />
      <Stat label={formatMessage({ id: 'Hosting' })} data={hostingSinceText} divider={true} />
    </div>
  );
};
